import { LayoutType } from '@sbercloud/uikit-product-utils';

import { Fn } from '@/types/common';
import { LayoutContextData } from '@/types/ssr';
import { equals } from '@/utils/common';
import { isLargeThan } from '@/utils/layout';

export const getUrlAnchor = (url: string) => {
  const anchorIndex = url.indexOf('#');
  if (equals(anchorIndex, -1)) return '';
  return url.slice(anchorIndex, url.length);
};

export const removeAnchorFromUrlString = (url: string) => {
  const anchor = getUrlAnchor(url);
  if (anchor) return url.replace(anchor, '');
  return url;
};

export const getScrollToAnchorOffsetDelta = (layoutType: LayoutType, isMainPage: boolean) => {
  const MAIN_PAGES_ANCHOR_OFFSETS_DELTA = {
    mobile: 150,
    desktop: 320,
  };

  if (!isMainPage) return 0;
  if (isLargeThan('mobile', layoutType)) return MAIN_PAGES_ANCHOR_OFFSETS_DELTA.desktop;
  return MAIN_PAGES_ANCHOR_OFFSETS_DELTA.mobile;
};

export const scrollToAnchor = (
  elementID: string,
  config: {
    layoutWrapperRef: LayoutContextData['layoutWrapperRef'];
    scrollBehavior?: ScrollBehavior;
    onSuccessScroll?: Fn<number, void>;
    offsetDelta?: number;
  },
) => {
  const el = document.getElementById(elementID);
  const layoutWrapperRef = config.layoutWrapperRef;
  if (el && layoutWrapperRef) {
    layoutWrapperRef.current?.scrollTo({
      top: el.offsetTop + (config.offsetDelta || 0),
      behavior: config?.scrollBehavior || 'auto',
    });
    config?.onSuccessScroll?.(Date.now());
  }
};
